
import { PlayNumber } from "./PlayNumber"
import Stack from '@mui/material/Stack'

export const PlayNumbers = ({title, group, numbers}) => {

 
  return (
   
    <div>
        <label style={{fontWeight:'500'}}>{title}</label>
        <Stack direction="row" spacing={2}  flexWrap="wrap"  useFlexGap >

        {
        Array.isArray(numbers) &&
            numbers.map((item) => (
            <PlayNumber play = {true} group={group} number={item}/>
        ))
        
        }
        </Stack>
      
    </div> 

  )
}
  